//store
import { observable } from 'mobx';
import axios from 'axios';
//config
import config from '../config'
//store
import profile from './profile'
import events from './events'
import prompt from '../store/prompt';
import widget from './widget'

class Panels {
  @observable newPanel = {
    tool: '',
    type: '',
    eventName: '',
    property: '',
    panelName: '',
    properties: null,
    panelId: ''
  }
  @observable list = [];
  @observable loading = true;
  createPanel() {
    let self = this;
    self.newPanel.panelName = `${self.newPanel.tool} ${self.newPanel.type} ${self.newPanel.eventName} ${self.newPanel.property}`;
    //POST panel to database
    prompt.message('事件創建中,請稍等...', null)
    axios.post(`${config.env.server}/iot/panel`, {
      tool: self.newPanel.tool,
      type: self.newPanel.type,
      eventName: self.newPanel.eventName,
      property: self.newPanel.property,
      panelName: self.newPanel.panelName,
      apiKey: profile.apiKey,
      eventAPIKey: events.getAPIKey(self.newPanel.eventName)
    })
      .then(function (response) {
        if (response.data.message == 'PANEL INSERT' && response.status === 200) {

          self.newPanel.panelId = response.data.panelId
          self.newPanel.eventAPIKey = response.data.eventAPIKey;
          prompt.message('面板創建成功.')
          //fetch exsit data
          axios.get(`${config.env.server}/iot/data/apikey/${profile.apiKey}/event/${self.newPanel.eventName}/property/${self.newPanel.property}`)
            .then(function (res) {
              if (res.data.data.length === 0) {
                self.newPanel.data = [];
              } else {
                self.newPanel.data = res.data.data
              }
              self.list.push(self.newPanel);
              self.loading = false;
              self.initPanel();
            })
            .catch(function (error) {
              console.log(error);
            })
        } else {
          prompt.message('面板創建失敗.請確保數據為純數字格式.', 3000)
        }
      })
      .catch(error => {
        prompt.message('面板創建失敗.請確保數據為純數字格式..', 3000)
        console.log(error)
      })
  }
  updatePanel() {
    let self = this;
    self.newPanel.panelName = `${self.newPanel.tool} ${self.newPanel.type} ${self.newPanel.eventName} ${self.newPanel.property}`;
    //POST panel to database
    prompt.message('事件修改中,請稍等...', null)
    axios.post(`${config.env.server}/iot/updatepanel`, {
      tool: self.newPanel.tool,
      type: self.newPanel.type,
      eventName: self.newPanel.eventName,
      property: self.newPanel.property,
      panelName: self.newPanel.panelName,
      apiKey: profile.apiKey,
      panelId: self.newPanel.panelId,
      eventAPIKey: events.getAPIKey(self.newPanel.eventName)
    })
      .then(function (response) {
        if (response.data && response.status === 200) {
          axios.get(`${config.env.server}/iot/data/apikey/${profile.apiKey}/event/${self.newPanel.eventName}/property/${self.newPanel.property}`)
            .then(function (res) {
              let arr = self.list.map(x => {
                let val = x;
                if (x.panelId === response.data.panelId) {
                  val = response.data
                  val.data = res.data.data
                }
                return val;
              })
              setTimeout(function () {
                self.list = arr
                self.initPanel();
              }, 100)
            })
            .catch(function (error) {
              console.log(error);
            })
          prompt.message('面板修改成功.', 1000)
        } else {
          prompt.message('面板修改失敗.', 3000)
        }
      })
      .catch(error => {
        prompt.message('面板修改失敗.', 3000)
        console.log(error)
      })
  }
  emptyPanel() {
    this.list = [];
  }
  fetchPanel() {
    let self = this;
    axios.get(`${config.env.server}/iot/panel`)
      .then(function (response) {
        let panelInfo = response.data;
        panelInfo.map(function (x) {
          axios.get(`${config.env.server}/iot/data/apikey/${x.apiKey}/event/${x.eventName}/property/${x.property}`)
            .then(function (res) {
              let panel = {
                tool: x.tool,
                type: x.type,
                eventName: x.eventName,
                property: x.property,
                panelName: x.panelName,
                data: res.data.data,
                eventAPIKey: x.eventAPIKey,
                panelId: x.panelId
              }
              self.list.push(panel);
            })
            .catch(function (err) {
              console.log(err);
            })
        })
      })
      .catch(err => console.log(err))
  }
  rsyncData() {
    let self = this;
    axios.get(`${config.env.server}/iot/panel`)
      .then(function (response) {
        let panelInfo = response.data;
        panelInfo.map(x => {
          let currentPanel = self.list.find(y => y.panelName == x.panelName);
          let latestId = currentPanel.data[currentPanel.data.length - 1].meta.id;
          if (x.tool === 'dataVisualization') {
            axios.post(`${config.env.server}/iot/data/apikey/${x.apiKey}/event/${x.eventName}/property/${x.property}`, {
              latestId: latestId
            })
              .then(function (res) {
                self.list.map(function (o) {
                  if (o.panelName == x.panelName) {
                    res.data.data.map(y => o.data.push(y));
                  }
                })
              })
              .catch(function (err) {
                if (err.response.status === 404) {
                  console.log('EVENT HAS BEEN DELETED', x.panelName);
                }
              })
          }
        })
      })
      .catch(function (error) {
        if (error) {
          console.log(error);
        }
      })
  }
  syncData() {
    let self = this;
    axios.get(`${config.env.server}/iot/panel`)
      .then(function (response) {
        let panelInfo = response.data;
        panelInfo.map(function (x) {
          // x.tool === 'widget'
          //   ? null
          //   : 
          axios.get(`${config.env.server}/iot/data/apikey/${x.apiKey}/event/${x.eventName}/property/${x.property}`)
            .then(function (res) {
              self.list.map(function (e) {
                if ((e.panelName === x.panelName) && (e.data.length !== res.data.data.length)) {
                  e.data = res.data.data;
                }
              })
            })
            .catch(function (err) {
              if (err.response.status == 404) {
                console.log('EVENT HAS BEEN DELETED', x.panelName);
              }
            })
        })
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  initPanel() {
    this.newPanel = {
      tool: '',
      type: '',
      eventName: '',
      property: '',
      properties: null,
    };
  }
  removePanel(panelName) {
    prompt.message('面板正在刪除中,請稍等...', null);
    axios.delete(`${config.env.server}/iot/panel`, {
      data: {
        panelName: panelName,
      }
    })
      .then(res => {
        if (res.status === 200) {
          let panelList = [];
          this.list.map(x => panelList.push(x.panelName));
          let panelIndex = panelList.indexOf(panelName);
          this.list.splice(panelIndex, 1);
          prompt.message('面板刪除成功.', 2000);
        }
      })
      .catch(error => console.log(error))
  }
  getEventProperty() {
    this.newPanel.properties = null;
    let self = this;
    axios.get(`${config.env.server}/iot/data/apikey/${profile.apiKey}/event/${this.newPanel.eventName}`)
      .then(function (response) {
        let arr = []
        // self.newPanel.properties = response.data;
        for (const key in response.data.data[0]) {
          if (key !== 'meta') {
            arr.push(key)
          }
        }
        self.newPanel.properties = arr;
      })
      .catch(error => console.log(error))
  }
}

var panels = window.panels = new Panels;

export default panels;



// WEBPACK FOOTER //
// ./src/store/panels.js